import {
  categories_tab,
  menus_tab,
  modifier_groups_tab,
  modifiers_tab,
  products_tab,
} from '../../../../../../views/menu/smart-pricing';
import { SMART_PRICING_RESOURCE_TYPE } from '../../../../../../services/exports/Constants';

export default {
  title: 'Preços inteligentes',
  master_title: 'Modo marca - Preços inteligentes',
  sections: {
    how_it_works: {
      title: 'Como funciona',
      description:
        'Os preços inteligentes são uma funcionalidade que permite controlar os preços com base nos métodos de encomenda utilizados pelo cliente. Cobre múltiplos cenários, como reduzir o preço para recolha, aumentar para entrega, adicionar descontos em menus sazonais, etc. Pode criar regras em vários níveis (Global, Menu, Categoria, Produto, Grupo de modificadores, Modificador). Os níveis funcionam como uma árvore, em que o nível superior afeta os inferiores. Ao mesmo tempo, a regra de nível inferior tem maior prioridade (ex.: uma regra de 5% de desconto na recolha numa Categoria específica substitui o desconto global de 15% na recolha para os seus produtos).',
    },
  },
  tabs: {
    [SMART_PRICING_RESOURCE_TYPE.company]: 'Regras globais',
    [SMART_PRICING_RESOURCE_TYPE.franchise]: 'Regras globais',
    [menus_tab]: 'Regras de menu',
    [categories_tab]: 'Regras de categoria',
    [products_tab]: 'Regras de produto',
    [modifier_groups_tab]: 'Regras de grupo de modificadores',
    [modifiers_tab]: 'Regras de modificadores',
  },
  fields: {
    name: 'Nome',
    order_methods: 'Métodos de encomenda',
    modifier: 'Modificador',
    image: 'Imagem',
    actions: 'Ações',
  },
  labels: {
    absolute: 'Absoluto',
  },
  buttons: {
    add_rule: 'Adicionar regra',
    edit: 'Editar',
    delete: 'Eliminar ({{count}})',
    images: 'Gerir imagem',
  },
  popups: {
    delete_rule: {
      title: 'Tem a certeza?',
    },
  },
  toasts: {
    failed_to_load_data: 'Erro ao carregar dados',
    failed_to_delete: 'Erro ao eliminar regras',
    deleted_successfully: 'Regras eliminadas com sucesso',
  },
};
